import React from "react";
import { Status } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const WrapupStatus = (props) => {
  const { size } = props;

  return <Status data-testid="wrapUpStatus" className="wrap-up" size={size} />;
};

WrapupStatus.propTypes = {
  size: PropTypes.string,
};

WrapupStatus.defaultProps = {
  size: "larger",
};

export default WrapupStatus;